<template>
  <div class="function-details">
    <div class="info">
      <div class="media" style="margin-top: 10px; width: 100%">
        <div
          class="media-label text-center"
          :class="activeTab == 1 ? 'active' : ''"
        >
          <router-link to="/product/exam">在线考试</router-link>
        </div>
        <div>
          <ul class="media-body-item">
            <li>
              <router-link to="/product/exam?to=section1">
                <img src="@/static/images/icon_system.svg" />
                <div>
                  <p>系统功能强大</p>
                </div>
              </router-link>
            </li>
            <li>
              <router-link to="/product/exam?to=section3">
                <img src="@/static/images/icon_ai.svg" />
                <div>
                  <p>AI智能防作弊</p>
                </div>
              </router-link>
            </li>
            <li>
              <router-link to="/product/exam?to=section5">
                <img src="@/static/images/icon_client.svg" />
                <div>
                  <p>客户端</p>
                </div>
              </router-link>
            </li>
            <li>
              <router-link to="/product/exam?to=section6">
                <img src="@/static/images/icon_stable.svg" />

                <div>
                  <p>系统稳定高并发</p>
                </div>
              </router-link>
            </li>
            <li>
              <router-link to="/product/exam?to=section7">
                <img src="@/static/images/icon_bank.svg" />
                <div>
                  <p>专业大题库</p>
                </div>
              </router-link>
            </li>
            <li>
              <router-link to="/product/exam?to=section8">
                <img src="@/static/images/icon_testing.svg" />
                <div>
                  <p>在线测评</p>
                </div>
              </router-link>
            </li>
            <li>
              <router-link to="/product/exam?to=section9">
                <img src="@/static/images/icon_mark.svg" />
                <div>
                  <p>试题判卷</p>
                </div>
              </router-link>
            </li>
            <li>
              <router-link to="/product/exam?to=section10">
                <img src="@/static/images/icon_statistics.svg" />
                <div>
                  <p>统计分析</p>
                </div>
              </router-link>
            </li>
            <li>
              <router-link to="/product/exam?to=section11">
                <img src="@/static/images/icon_operate.svg" />
                <div>
                  <p>特色运营服务</p>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="media" style="width: 100%">
        <div
          class="media-label text-center"
          :class="activeTab == 2 ? 'active' : ''"
          style="margin-top: 14px"
        >
          <router-link to="/product/interview">在线面试</router-link>
        </div>
        <div class="media-body">
          <ul class="media-body-item">
            <li>
              <router-link to="/product/interview?to=section2">
                <img src="@/static/images/icon_interview.svg" />
                <div>
                  <p>单面、群面多种模式</p>
                </div>
              </router-link>
            </li>
            <li>
              <router-link to="/product/interview?to=section4">
                <img src="@/static/images/icon_video.svg" />
                <div>
                  <p>视频流畅、不卡顿</p>
                </div>
              </router-link>
            </li>
            <li>
              <router-link to="/product/interview?to=section3">
                <img src="@/static/images/icon_trait.svg" />
                <div>
                  <p>特色面试功能</p>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: 0,
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val != oldVal) {
          this.judgePath()
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  mounted() {
    this.judgePath()
  },
  methods: {
    judgePath() {
      if (this.$route.path == '/product/exam') {
        this.activeTab = 1
      }
      if (this.$route.path == '/product/interview') {
        this.activeTab = 2
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.function-details {
  position: absolute;
  cursor: auto;
  margin-left: -50px;
  width: 840px;
  background-color: #ffffff;
  border-top: solid 4px #29bdb9;
  box-shadow: 0px 8px 15px 0px rgba(196, 196, 196, 0.35);
  transition: all 0.33s ease;
  z-index: 1;
  a {
    text-decoration: none;
    color: rgb(102, 102, 102);
    &:hover {
      color: #29bdb9;
    }
  }
  .active a {
    color: #29bdb9;
  }
  .info {
    display: block;
    .media {
      display: block;
      padding: 10px 0px 0px;
      float: left;
      width: 100%;
      &:last-child {
        padding-top: 20px;
        border-top: 1px solid #ddd;
      }
    }
  }
}
.media-label {
  float: left;
  width: 88px;
  font-size: 20px;
  line-height: 24px;
  color: rgb(102, 102, 102) 333;
  margin: 40px 58px 65px 58px;
  &.active {
    color: #29bdb9;
  }
}
.media-body-item {
  margin-top: 15px;
}
.media-body-item > li {
  float: left;
  width: 212px;
  height: 30px;
  margin-bottom: 20px;
  position: relative;
  text-align: left;
  .iconfont {
    font-size: 20px;
    color: #666;
    position: absolute;
  }
}

.media-body-item > li:hover {
  div {
    color: #29bdb9;
  }
  .iconfont {
    color: #29bdb9;
  }
}
.media-body-item > li > a:visited,
.media-body-item > li > a:link {
  text-decoration: none;
}
.media-body-item > li img {
  position: absolute;
}
.media-body-item > li div {
  margin-left: 30px;
  font-size: 14px;
  color: rgb(102, 102, 102) 333;
  p {
    margin: 0px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header/product/index.vue